const PRIMART_DELIMETER = ';'
const INNER_DELIMETER = '='
const OOI_VERSIONS_POSTFIX = 'cssConfig.bundle.min.js'

export type ModulesToLoad = Array<{ id: string; url: string }>

const urlMappings = [
	['https://static.parastorage.com/services/', 'p.'],
	['https://sled.wix.dev/sled-wixplatform-bundle/', 's.'],
]

const compressUrl = (url: string) => {
	return urlMappings.reduce(
		(acc, [pattern, replacer]) =>
			acc.replace(pattern, replacer).replace(new RegExp(`${OOI_VERSIONS_POSTFIX}$`), ''),
		url
	)
}

const decompressUrl = (compressedUrl: string) => {
	return urlMappings.reduce(
		(acc, [pattern, replacer]) =>
			(acc.slice(0, replacer.length) === replacer ? pattern + acc.slice(2) : acc).replace(
				/\.$/,
				`.${OOI_VERSIONS_POSTFIX}`
			),
		compressedUrl
	)
}

export const encodeModulesToLoad = (items: ModulesToLoad) =>
	encodeURIComponent(items.map(({ id, url }) => `${id}${INNER_DELIMETER}${compressUrl(url)}`).join(PRIMART_DELIMETER))

export const decodeModulesToLoad = (raw: string): ModulesToLoad =>
	decodeURIComponent(raw)
		.split(PRIMART_DELIMETER)
		.filter(Boolean)
		.map((item) => {
			const [id, url] = item.split(INNER_DELIMETER)
			return { id, url: decompressUrl(url) }
		})
